const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuotesLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 422 352",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-697.323,-5364.92)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.819491,0,0,1,91.3003,-0.0807647)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.22027,0,0,1,614.903,-51.1272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.498,5611.6C236.803,5618.34 221.397,5622.13 205.114,5622.13C148.268,5622.13 102.115,5575.98 102.115,5519.13C102.115,5462.28 148.268,5416.13 205.114,5416.13C261.961,5416.13 308.113,5462.28 308.113,5519.13C308.113,5522.13 307.985,5525.1 307.733,5528.03C308.063,5530.05 308.184,5532.45 308.073,5535.27C301.045,5712.72 178.245,5767.9 178.245,5767.9C178.245,5767.9 258.695,5682.9 250.498,5611.6Z",
    style: {
      fill: "rgb(228,231,228)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.819491,0,0,1,91.3003,-0.0807647)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.22027,0,0,1,877.635,-51.1272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.498,5611.6C236.803,5618.34 221.397,5622.13 205.114,5622.13C148.268,5622.13 102.115,5575.98 102.115,5519.13C102.115,5462.28 148.268,5416.13 205.114,5416.13C261.961,5416.13 308.113,5462.28 308.113,5519.13C308.113,5522.13 307.985,5525.1 307.733,5528.03C308.063,5530.05 308.184,5532.45 308.073,5535.27C301.045,5712.72 178.245,5767.9 178.245,5767.9C178.245,5767.9 258.695,5682.9 250.498,5611.6Z",
    style: {
      fill: "rgb(228,231,228)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotesLight);
export default __webpack_public_path__ + "static/media/Quotes_light.176685e87eac0113b06361d2f6f1316d.svg";
export { ForwardRef as ReactComponent };